export var EPaymentConstant = /*#__PURE__*/function (EPaymentConstant) {
  EPaymentConstant[EPaymentConstant["KopeikiPerRuble"] = 100] = "KopeikiPerRuble";
  return EPaymentConstant;
}({});